export default __webpack_public_path__ + "static/media/lineRed.da14ff93.svg";